import React from 'react'

const Logo: React.FC = () => {
	return <img alt="logo" src="/img/logo.png" width={180} />
}

export default Logo
